import { createStyles } from "@mantine/core";

export const useDocumentStyles = createStyles((theme) => ({
  refreshButton: {
    backgroundColor: "#3B82F6",
    color: "#FFFFFF",
    border: "none",
    padding: "0.5rem 1rem",
    borderRadius: "8px",
    cursor: "pointer",
    fontSize: "1rem",
    fontWeight: "500",
    transition: "background-color 0.3s",
    ":hover": {
      backgroundColor: "#2563EB",
    },
    ":disabled": {
      backgroundColor: "#94A3B8",
      cursor: "not-allowed",
    },
  },

  refreshButtonLoading: {
    backgroundColor: "#2563EB",
    cursor: "wait",
    ":hover": {
      backgroundColor: "#2563EB",
    },
  },

  filePreview: {
    textAlign: "center",
    fontSize: "1rem",
    fontWeight: "500",
    color: "#374151",
    marginTop: "1rem",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },

  uploadButton: {
    marginTop: "1rem",
    backgroundColor: "#3B82F6",
    color: "#FFFFFF",
    border: "none",
    padding: "0.5rem 1.5rem",
    borderRadius: "8px",
    cursor: "pointer",
    fontSize: "1rem",
    fontWeight: "500",
    textAlign: "center",
    transition: "background-color 0.3s",
    ":hover": {
      backgroundColor: "#2563EB",
    },
    ":disabled": {
      backgroundColor: "#94A3B8",
      cursor: "not-allowed",
    },
  },

  container: {
    width: "100%",
    padding: "2rem",
    backgroundColor: "#F9FAFC",

    "@media (max-width: 768px)": {
      padding: "1rem",
    },
  },
  viewButton: {
    backgroundColor: "#22C55E",
    color: "#FFFFFF",
    border: "none",
    padding: "0.25rem 0.75rem",
    
    borderRadius: "4px",
    gap: "0.5rem",
    cursor: "pointer",
    fontSize: "0.875rem",
    fontWeight: "500",
    transition: "background-color 0.3s",
    ":hover": {
      backgroundColor: "#16A34A",
    },
  },

  tableResponsiveWrapper: {
    width: "100%",
    overflowX: "auto", // Enable horizontal scrolling
    borderRadius: "8px",
    boxShadow: "0 1px 4px rgba(0, 0, 0, 0.1)",

    "@media (max-width: 768px)": {
      overflowX: "scroll",
      "-webkit-overflow-scrolling": "touch", // Smooth scrolling on mobile
    },
  },

  /* Upload Section */
  uploadSection: {
    width: "100%",
    marginBottom: "2rem",
    backgroundColor: "#FFFFFF",
    borderRadius: "8px",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    overflow: "hidden",
    padding: "20px",
  },

  dropzone: {
    width: "100%",
    height: "200px",
    border: "2px dashed #CBD5E1",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    cursor: "pointer",
    transition: "border-color 0.3s",
    ":hover": {
      borderColor: "#3B82F6",
    },
  },

  dropzoneContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "0.5rem",
    color: "#374151",
    span: {
      fontSize: "0.875rem",
      color: "#6B7280",
    },
  },

  /* Table Section */
  tableSection: {
    backgroundColor: "#FFFFFF",
    borderRadius: "8px",
    boxShadow: "0 1px 4px rgba(0, 0, 0, 0.1)",
    padding: "1.5rem",
  },

  tableTitle: {
    fontSize: "1.5rem",
    fontWeight: 600,
    marginBottom: "1rem",
  },

  table: {
    width: "100%",
    borderCollapse: "collapse",
    tableLayout: "fixed",
    minWidth: "600px", // Ensure table is scrollable on mobile

    "th, td": {
      padding: "0.75rem",
      textAlign: "left",
      fontSize: "0.875rem",
      whiteSpace: "nowrap", // Prevent text wrapping for better readability
      width:"25%"
    },

    td: {
      color: "#000f04",
    },
  },

  loadMoreBtn: {
    marginTop: "1.5rem",
    width: "100%",
    backgroundColor: "#3B82F6",
    color: "#FFFFFF",
    borderRadius: "8px",
    ":hover": {
      backgroundColor: "#2563EB",
    },
  },

  tableHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "1rem",
  },
}));
